import { render, staticRenderFns } from "./ContentRiskMessages.vue?vue&type=template&id=52e73ad4&scoped=true"
import script from "./ContentRiskMessages.vue?vue&type=script&lang=js"
export * from "./ContentRiskMessages.vue?vue&type=script&lang=js"
import style0 from "./ContentRiskMessages.vue?vue&type=style&index=0&id=52e73ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e73ad4",
  null
  
)

export default component.exports